import { useState, useCallback, useContext, useMemo, Suspense, useEffect } from "react";
import FormSingleAction from "../../../../../shared/enrollment/formSingleAction/FormSingleAction";
import { useHistory, useLocation } from "react-router-dom";
import {
	KsopHeaderInformation,
	KsopPersonalInformation,
	KsopBeneficiaryName,
	KsopPartcipantSignature,
	KsopBeneficiaryDesignation
} from "../../../..";
import { PlanFormProps } from "../../../../../../types/components/enrollmentProps.types";
import {
	BeneficieryDetails,
	BeneficieryPayload,
	KSOPCommonDetails,
	KSOPOption
} from "../../../../../../types/enrollment.types";
import { getCurrentDate, manualDateComparator } from "../../../../../../utils/commonFunctions/date";
import { AddEnrollmentPayload, AddKSOPEnrollmentPayload } from "../../../../../../utils/api/enrollment/enrollment";
import { AuthContext, GroupEnrollmentContext, GroupOwnerContext, PaycheckContext } from "../../../../../../contexts";
import { api } from "../../../../../../utils/api";

import "./ksopForm.css";
import { LazyCustomFormDialog } from "../../../../../shared";
import { generateKsopWaiveEnrollmentPayload } from "../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { CustomFormDialogType } from "../../../../../../types/components/dialogProps.types";
import PlanActions from "../../../../../shared/enrollment/planActions/PlanActions";
import { trackPromise } from "react-promise-tracker";

const KsopForm = ({ getEnrollmentInitData, openEnrollment }: PlanFormProps) => {
	const { member } = useContext(AuthContext);
	const [waiveReason, setWaiveReason] = useState("");
	const [isWaiveEnrollmentTriggered, setIsWaiveEnrollmentTriggered] = useState(false);
	const { paycheck } = useContext(PaycheckContext);
	const history = useHistory();
	const location = useLocation();
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(GroupEnrollmentContext);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [KSOPOption, setKSOPOption] = useState<KSOPOption | null>(null);
	const { groupOwner } = useContext(GroupOwnerContext);
	const [primaryBeneficiery, setPrimaryBeneficiery] = useState<BeneficieryDetails[]>([
		{
			id: 1,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 2,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 3,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 4,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		}
	]);
	const [contingentBeneficiery, setContingentBeneficiery] = useState<BeneficieryDetails[]>([
		{
			id: 1,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 2,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 3,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 4,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		}
	]);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateKsopWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveReason
		);
		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: { ...commonDetails, agent_id: groupOwner && groupOwner._id ? groupOwner._id : null }
		};
		const response = await api.enrollment.addEnrollment(enrollmentPayload);
		if (response) {
			getEnrollmentInitData(false);
		}
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=2`);
	}, [getEnrollmentInitData, history, member, openEnrollment, urlSearchParams, waiveReason]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							// handleWaiveEnrollment();
							setIsWaiveEnrollmentTriggered(true);
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const validateKSOPBeneficieryDetails = useCallback(
		(beneficiery: BeneficieryDetails[], type: "primary" | "contingent") => {
			let sum = 0;
			let _dob;
			let isValid = true;
			for (let i = 0; i < beneficiery.length; i++) {
				const { name, date_of_birth, relationship, percentage, address, SSN } = beneficiery[i];
				if (
					name !== "" &&
					date_of_birth !== "" &&
					relationship !== "" &&
					percentage !== "" &&
					address !== "" &&
					SSN !== ""
				) {
					_dob = date_of_birth.split("/");
					if (_dob[2].length < 4) {
						alert(`Invalid year in ${type}. Valid date format MM/DD/YYYY`);
						isValid = false;
						return isValid;
					}

					sum = sum + parseInt(percentage);
					// console.log("Sum", sum);
				} else if (
					name === "" &&
					date_of_birth === "" &&
					relationship === "" &&
					percentage === "" &&
					address === "" &&
					SSN === ""
				) {
					continue;
				} else {
					isValid = false;
					alert(`Please fill all the field in ${type} beneficiary`);
					break;
				}
			}
			// console.log("Sum", sum);
			if (sum === 0 && type === "primary") {
				isValid = false;
				alert("You must have at least one primary beneficiery");
				return isValid;
			}
			if (sum !== 100 && sum !== 0) {
				alert(`Total Percentage must be equal to  100 in ${type} beneficiary `);
				isValid = false;
				return isValid;
			}
			return isValid;
		},
		[]
	);

	const generateBeneficieryPayload = useCallback((beneficiery: BeneficieryDetails[]): BeneficieryPayload[] => {
		const beneficieryPayload: BeneficieryPayload[] = [];
		beneficiery.forEach((eachBeneficiery: BeneficieryDetails) => {
			const { name, SSN, relationship, date_of_birth, address, percentage } = eachBeneficiery;
			const _ssn = SSN.replaceAll("-", "");
			beneficieryPayload.push({
				name,
				SSN: SSN.replaceAll("-", ""),
				relationship,
				date_of_birth,
				address,
				percentage: Number(percentage)
			});
		});
		return beneficieryPayload;
	}, []);

	const handleActivateEnrollment = useCallback(async () => {
		if (KSOPOption === null) {
			alert("You must select one option from Beneficiary Designation Choices");
			return;
		}
		if (KSOPOption === null || member === null || openEnrollment === null || paycheck === null) {
			return;
		}
		const primary_beneficiery = generateBeneficieryPayload(primaryBeneficiery);
		const contingent_beneficiery = generateBeneficieryPayload(contingentBeneficiery);

		const currentDate = new Date() as unknown as string;
		const planStartDate = openEnrollment.plan.start_date; // -1 or 0
		const planDateComparison: number = manualDateComparator(planStartDate, currentDate);

		const effectiveDate = openEnrollment.plan.auto_approve
			? planDateComparison === -1 || planDateComparison === 0
				? getCurrentDate()
				: null
			: null;

		const enrollmentCommonDetails: KSOPCommonDetails = {
			agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
			location_number: member.location.location_number,
			location_name: member.location.location_name,
			group_number: member.group_number,
			group_name: member.group.name,
			plan_object_id: openEnrollment.plan._id,
			plan_code: openEnrollment.plan.plan_code,
			plan_name: openEnrollment.plan.plan_name,
			base_plan_name: openEnrollment.plan.plan_name,
			insured_object_id: member._id,
			insured_SSN: member.SSN,
			writing_number: 0,
			unenrolled_reason: null,
			waive_reason: null,
			termination_reason: null,
			enrollment_date: getCurrentDate(),
			effective_date: null,
			termination_date: null,
			open_enrollment_id: openEnrollment._id,
			total_premium: 0,
			KSOP_option: KSOPOption,
			primary_beneficiery,
			contingent_beneficiery
		};
		const enrollmentPayload: AddKSOPEnrollmentPayload = {
			common_details: enrollmentCommonDetails,
			standard_details: [
				{
					member_object_id: member._id,
					member_SSN: member.SSN,
					coverage_code: "EE",
					premium_amount: 0,
					is_tobacco: false
				}
			]
		};
		const response = await trackPromise(api.enrollment.addEnrollment(enrollmentPayload));
		if (response) {
			const step = urlSearchParams.get("step");
			getEnrollmentInitData(false);
			history.push(`?step=${step}&stage=0`);
		}
	}, [
		KSOPOption,
		contingentBeneficiery,
		generateBeneficieryPayload,
		getEnrollmentInitData,
		history,
		member,
		openEnrollment,
		paycheck,
		primaryBeneficiery,
		urlSearchParams
	]);

	const handleSubmitClick = useCallback(async () => {
		const isPrimaryValid = validateKSOPBeneficieryDetails(primaryBeneficiery, "primary");
		if (isPrimaryValid === false) {
			return;
		}
		const isContingentValid = validateKSOPBeneficieryDetails(contingentBeneficiery, "contingent");
		if (isContingentValid === false) {
			return;
		}
		if (KSOPOption === null) {
			alert("You must select one option from Beneficiary Designation Choices");
			return;
		}
		handleActivateEnrollment();
	}, [
		validateKSOPBeneficieryDetails,
		primaryBeneficiery,
		contingentBeneficiery,
		KSOPOption,
		handleActivateEnrollment
	]);

	// console.log("Primary ", primaryBeneficiery);
	// console.log("Contingent", contingentBeneficiery);

	useEffect(() => {
		if (openEnrollment) {
			// setCurrentEnrollment(
			// 	Object.assign(
			// 		{},
			// 		{
			// 			plan_name: openEnrollment.plan.plan_name,
			// 			status: "Current",
			// 			premium_amount: 0
			// 		}
			// 	)
			// );
		}
	}, [openEnrollment]);

	useEffect(() => {
		if (isWaiveEnrollmentTriggered) {
			handleWaiveEnrollment();
			setIsWaiveEnrollmentTriggered(false); // Reset the trigger
		}
	}, [isWaiveEnrollmentTriggered, handleWaiveEnrollment]);

	return (
		<div className="ksop-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<div className="ksop-header-information" id="ksop-header-information">
				<KsopHeaderInformation />
			</div>
			<div className="ksop-personal-information" id="ksop-personal-information">
				<KsopPersonalInformation />
			</div>
			<div className="ksop-beneficiary-designation">
				<KsopBeneficiaryDesignation KSOPOption={KSOPOption} setKSOPOption={setKSOPOption} />
			</div>
			<div className="ksop-beneficiary-name" id="ksop-beneficiary-name">
				<KsopBeneficiaryName
					primaryBeneficiery={primaryBeneficiery}
					contingentBeneficiery={contingentBeneficiery}
					setPrimaryBeneficiery={setPrimaryBeneficiery}
					setContingentBeneficiery={setContingentBeneficiery}
				/>
			</div>
			{/* <div className="ksop-name-change" id="ksop-name-change">
				<KsopNameChange />
			</div> */}
			<div className="ksop-participant-signature" id="ksop-participant-signature">
				<KsopPartcipantSignature />
			</div>
			<div className="buttom-flex">
				<p>GP 24488-26</p>
				<div>
					<p style={{ textAlign: "center" }}>Please retain a copy for your records</p>
					<p>
						<b>THIS FORM MUST BE RETURNED TO THE BENEFITS DEPARTMENT</b>
					</p>
				</div>
				<p>05/2008</p>
			</div>
			<div className="theme-plan-section-margin" />
			<PlanActions waiveButtonCallback={handleWaiveButtonClick} activateButtonCallback={handleSubmitClick} />
		</div>
	);
};

export default KsopForm;
